import { HTMLAttributes } from 'react'

export interface EmbedProps extends HTMLAttributes<HTMLIFrameElement> {
  /** Source of the iframe */
  src: string
  /** default to true */
  scrolling?: boolean
  /** Title of the iframe */
  title?: string
  /** Sandbox of the iframe */
  sandbox?: string
}

export function Embed({
  src,
  scrolling = true,
  title = '',
  className, // for outer wrapper tweaks
  sandbox = 'allow-scripts allow-same-origin allow-forms allow-popups allow-popups-to-escape-sandbox allow-top-navigation',
}: EmbedProps) {
  return (
    <div
      className={`relative w-full h-full ${className ?? ''} overflow-scroll`}
    >
      <iframe
        src={src}
        title={title}
        className={`
          absolute inset-0
          w-full h-full
          ${scrolling ? 'overflow-y-scroll' : 'overflow-y-hidden'}
        `}
        sandbox={sandbox}
      />
    </div>
  )
}
